import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./redux/ConfigureStore";
import { Provider as ReduxProvider } from "react-redux";


//import "./style/bootstrap.min.css";
import "./style/fontawesome-free/css/all.min.css";
import "./style/RevShareStyle.css";
const store = configureStore();

ReactDOM.render(
  <ReduxProvider store={store}>
    <Router>

        <App />        


    </Router>
  </ReduxProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
